import Styles from './styles.module.scss';

import { ShareIcon } from '@/components/Elements/Icons';

export const Details = () => {
	return (
		<div className={Styles.detailsContainer}>
			<ShareIcon />
			<span>N/A</span>
		</div>
	);
};
